import { ListItemBox } from "lib/@components/ListItemBox"
import { Bound } from "lib/@components/binding/Bound"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { useRefresh } from "lib/@hooks/useRefresh"
import { BoundEditableBox } from "lib/@components/editable/editableText"
import { EditableBox } from "lib/@components/editable/editableBox"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function CodeEditor({
    isCore,
    clientCode,
    schedule,
    field = "code",
    clientCodeField = "clientCode",
    uniqueCodeField = "uniqueCode",
}) {
    const { editMode, target } = useBoundContext()
    clientCode ??= schedule.clientCode
    isCore ??= schedule.ScheduleType !== 2
    const { originatingScheduleId, originatingScheduleCode = "", clientScheduleId = 1 } = schedule
    const [part1, part2] = (originatingScheduleCode || "").split("-")
    const refresh = useRefresh()
    if (!isCore) {
        schedule[field] = `${!isCore ? "C" : ""}${originatingScheduleId ? `${part1}-${part2}-` : ""}${
            !isCore
                ? `${clientCode}-${clientScheduleId}${schedule[uniqueCodeField] ? `-${schedule[uniqueCodeField]}` : ""}`
                : ""
        }`
        schedule[clientCodeField] = clientCode
    }

    return (
        <Bound target={schedule} refresh={refresh}>
            {!isCore ? (
                <ListItemBox sx={{ mt: 1, zoom: 1 }} alignItems="flex-end" data-cy="code-editor">
                    <EditableBox
                        sx={{
                            mr: 1,
                            borderColor: "action.selected",
                            width: "max-content",
                        }}
                        readOnly
                        value="C"
                    />

                    {!!originatingScheduleId && (
                        <>
                            <EditableBox
                                sx={{
                                    mr: 1,
                                    borderColor: "action.selected",
                                    width: "max-content",
                                }}
                                readOnly
                                value={part1}
                            />
                            <EditableBox
                                sx={{
                                    mr: 1,
                                    borderColor: "action.selected",
                                    width: "max-content",
                                }}
                                readOnly
                                value={part2}
                            />
                        </>
                    )}

                    <EditableBox
                        sx={{
                            mr: 1,
                            borderColor: "action.selected",
                            width: "max-content",
                        }}
                        readOnly
                        value={clientCode}
                    />
                    <EditableBox
                        sx={{
                            mr: 1,
                            borderColor: "action.selected",
                            width: "max-content",
                        }}
                        data-cy="client-schedule-id"
                        readOnly
                        value={clientScheduleId}
                    />
                    {(editMode || target[uniqueCodeField]) && (
                        <BoundEditableBox
                            sx={{
                                mr: 1,
                                flex: 1,
                                width: 1,
                                borderColor: "action.active",
                            }}
                            placeholder="Unique Code"
                            field={uniqueCodeField}
                            sideEffects
                            data-cy="unique-code-input"
                        />
                    )}
                </ListItemBox>
            ) : (
                <BoundTextField
                    field="code"
                    inputProps={{
                        readOnly: true,
                    }}
                />
            )}
        </Bound>
    )
}
